// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-draw-ugc {
  display: block;
  padding: 16px;
}
wm-draw-ugc wm-form {
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/draw-ugc/draw-ugc.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;AACJ","sourcesContent":["wm-draw-ugc {\n  display: block;\n  padding: 16px;\n\n  wm-form {\n    margin: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
